import { twMerge } from 'tailwind-merge';

export interface IFieldErrorMessage {
  className?: string;
  message?: string;
}

const FieldErrorMessage = ({ className, message }: IFieldErrorMessage) => {
  let mergedClasses = twMerge(
    'font-SFProDisplay text-[#F12929] text-sm font-normal',
    className ?? className
  );
  return <span className={mergedClasses}>{message}</span>;
};

export default FieldErrorMessage;
